import _curry2 from './_curry2';
import _flatCat from './_flatCat';
import map from '../map';

var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});
export default _xchain;


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_xchain.js
// module id = 1819
// module chunks = 1